// extracted by mini-css-extract-plugin
export default {"main":"review-table_main__Ylkz2","header":"review-table_header__8T5Ty","table":"review-table_table__nUyLT","th1":"review-table_th1__g6t6L"};